import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientReorderInputPage } from '@/feature/hotline/client/detail/reorder/input/page/HotlineClientReorderInputPage';
/**
 * 匿名ホットライン もう一度相談する 入力
 */
export const HotlineClientReorderInput = () => (_jsx(HotlineClientReorderInputPage, {}));
